import { OPEN, CLOSE } from './types';

const initialState = {
    activeModal: null,
};

const actionsHandlers = {
    [OPEN]: (state, action) => {
        return {
            ...state,
            activeModal: action.component,
        };
    },
    [CLOSE]: (state , action) => {
        return {
            ...state,
            activeModal: null,
        };
    },
};

const reducer = (state = initialState, action) => {
    const handler = actionsHandlers[action.type];
    return handler ? handler(state, action) : state;
};
export default reducer;
